import { PICKUP_ASSIGNMENT_TYPE, RECOMMENDATION_INFO } from '../constants';

export const getAssignRecommendationType = (pickupAssignmentType) => {
  if (pickupAssignmentType === PICKUP_ASSIGNMENT_TYPE.assignAll) {
    return { ...RECOMMENDATION_INFO.ASSIGN_ALL };
  }
  return { ...RECOMMENDATION_INFO.ASSIGN_SELECTED };
};
